import n from "./generateUtilityClasses.mjs";
import e from "./generateUtilityClass.mjs";
function r(t) {
  return e("MuiInputAdornment", t);
}
const i = n("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]), l = i;
export {
  l as default,
  r as getInputAdornmentUtilityClass
};
//# sourceMappingURL=inputAdornmentClasses.mjs.map
